export const SOCIAL_POST_TYPES = {
  IMAGE: "image",
  VIDEO: "video",
}
